import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { CartProvider } from "./lib/cart";
import { CurrencyProvider } from "./lib/currency";
import { initLenis, scrollToTop } from "./lib/lenis";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { CartDrawer } from "./components/CartDrawer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import Home from "./pages/Home";
import Products from "./pages/Products";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import LegalPage from "./pages/LegalPage";
import { LEGAL_DOCS } from "./data/legal";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-[#F8FAFC] px-6 text-center">
          <p className="font-display text-2xl font-bold text-slate-900">Something went wrong</p>
          <p className="text-sm text-slate-500">Please refresh the page. For support, email info@onecarelife.health</p>
        </div>
      );
    }
    return this.props.children;
  }
}

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollToTop(true);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <ErrorBoundary>
      <HelmetProvider>
        <CurrencyProvider>
          <CartProvider>
            <BrowserRouter>
              <ScrollManager />
              <div className="flex min-h-screen flex-col">
                <Navbar />
                <div className="flex-1">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:slug" element={<BlogPost />} />
                    <Route path="/privacy-policy" element={<LegalPage doc={LEGAL_DOCS.privacy} />} />
                    <Route path="/terms-and-conditions" element={<LegalPage doc={LEGAL_DOCS.terms} />} />
                    <Route path="/return-refund-policy" element={<LegalPage doc={LEGAL_DOCS.returns} />} />
                    <Route path="/shipping-policy" element={<LegalPage doc={LEGAL_DOCS.shipping} />} />
                    <Route path="*" element={<Home />} />
                  </Routes>
                </div>
                <Footer />
                <CartDrawer />
                <WhatsAppFloat />
              </div>
            </BrowserRouter>
          </CartProvider>
        </CurrencyProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;
